import React, { useState } from "react";
import { Card, CardBody, Container } from "reactstrap";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import GeneralTab from "./GeneralTab";
import Rules from "./Rules";
import { ModuleAccess } from "utils/moduleaccess";
import { ToastContainer } from "react-toastify";
import DispenseFees from "../DispenseFees";
import OrderingTab from "./OrderingTab"
import Addicon from "assets/icon/EditConfig.svg";


const ClientLevelConfigurationTabs = (props) => {
  const { ce, search, contractIds, refetch ,module, orgId, rowData, tenantID, data , searchTerms , selectedRowDynamic } = props;
  const [key, setkey] = useState("GeneralTab");
  const [reset, setReset] = useState(false);

  const onKeyChange = (k) => {
    setkey(k);
    setReset(!reset);
  };

  const hasPermission = (code) => {
    return ModuleAccess("Config", code);
  };

  return (
    <Container fluid className="my-3 bin_info">
      <Tabs
        id="controlled-tab-example"
        activeKey={key}
        onSelect={(k) => onKeyChange(k)}
        className="mb-3"
      >
        <Tab eventKey="GeneralTab" title="General">
           <GeneralTab data={data} rowData={rowData} searchTerms={searchTerms} refetch = {refetch} selectedRowDynamic = {selectedRowDynamic}/> 
        </Tab>
         <Tab eventKey="OrderingTab" title="Ordering">
           <OrderingTab data={data} rowData={rowData}  refetch = {refetch} /> 
        </Tab>
        <Tab eventKey = "DispenseFees" title = "Dispense Fee">
          <DispenseFees data={data} rowData={rowData}></DispenseFees>
        </Tab>
      </Tabs>
      {/* <ToastContainer position="top-right" autoClose={3000} /> */}
    </Container>
  );
};

export default ClientLevelConfigurationTabs;
